import { portalRoutes } from "./portalRoutes";
import { accountRoutes } from "./accountRoutes";
import { adminRoutes } from "./adminRoutes";

export const Routes = [
        ...portalRoutes,
        //...dashboardRoutes,
        // ...corporateRoutes,
        // ...userProfileRoutes,
        ...accountRoutes,
        //...errorRoutes,
        // ...aboutRoutes,
        ...adminRoutes,
];

export default Routes;
